/* generated using openapi-typescript-codegen -- do not edit */
/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
export enum RichTextToolbarElement {
    UNDO = 'undo',
    REDO = 'redo',
    COPY = 'copy',
    CUT = 'cut',
    BOLD = 'bold',
    ITALIC = 'italic',
    SUPERSCRIPT = 'superscript',
    SUBSCRIPT = 'subscript',
    FORECOLOR = 'forecolor',
    H1 = 'h1',
    H2 = 'h2',
    H3 = 'h3',
    HR = 'hr',
    BULLIST = 'bullist',
    NUMLIST = 'numlist',
    BLOCKQUOTE = 'blockquote',
    LINK = 'link',
    TABLE = 'table',
    IMAGE = 'image',
    CHARMAP = 'charmap',
    REMOVEFORMAT = 'removeformat',
    SAVE = 'save',
}
